// v3 — 현장 상세(/apt/{slug}) 라우트 판별.
//
// StickySignupBar(커밋 2) 와 StickyTalkBanner(커밋 6) 가 같이 쓴다.
// 두 곳 모두 "현장 상세에서만" 꺼져야 하는데, startsWith('/apt/') 로 잡으면
// /apt/busan · /apt/map 같은 허브까지 전부 죽는다.

/** /apt 아래 단일 세그먼트 라우트 중 현장 상세가 아닌 것들. */
export const APT_RESERVED_SEGMENTS = [
  'archive','area','big-events','builder','busan','compare','complex','data','diagnose',
  'gallery', // VX-4 화보 허브(/apt/gallery)
  'list', // google-llm A-4 — 지역 현장 전체 목록(/apt/list/{시도}/{시군구})
  'feed','landmark','map','pipeline','popular','ranking','redev','region','search',
  'sites','stage','theme','unsold','unsold-deals',
] as const;
const RESERVED = new Set<string>(APT_RESERVED_SEGMENTS);

// ④-1(2026-09-27) — ADSENSE_DETAIL_PAUSE_SCRIPT(상세 자동광고 멈춤 인라인)를 걷어냈다. 광고 로더는
//   components/ads/AdsGate.tsx 가 app_config ads/display_routes 로 라우트별 ON 일 때만 넣는다(상세 기본 OFF).
// E-0 ②(2026-09-26): 'archive'·'pipeline' 누락을 메웠다 — 둘 다 (main)/apt 아래 실존 허브인데
//   빠져 있어 «현장 상세» 로 오판됐다(밴드·TalkFab·AdBanner 등이 허브에서 상세 취급).
//   src/__tests__/top-band.test.ts 가 (main)/apt 디렉터리와 이 목록의 일치를 잠근다.

/**
 * '/apt/엄궁역-트라비스-하늘채' → true, '/apt/busan' → false, '/apt' → false
 *
 * 주의: /apt 아래 새 라우트를 추가하면 위 RESERVED 에도 넣어야 한다.
 * 안 넣으면 그 허브에서 카톡 배너가 꺼진다.
 */
export function isAptSiteDetailPath(pathname: string): boolean {
  const m = /^\/apt\/([^/]+)\/?$/.exec(pathname);
  return !!m && !RESERVED.has(decodeURIComponent(m[1]));
}
